import Icon from "@mui/icons-material/Receipt";
import LagatReceiptCreate from "./LagatReceiptCreate";
import LagatReceiptEdit from "./LagatReceiptEdit";
import LagatReceiptList from "./LagatReceiptList";

export default {
  list: LagatReceiptList,
  create: LagatReceiptCreate,
  edit: LagatReceiptEdit,
  icon: Icon,
  label: "Lagat Receipts",
  options: { label: "Lagat Receipts" },
  name: "lagatReceipts",
};
